export enum ResponseTypes {
  BLOB = 'blob'
}
